import { useMutation } from "@tanstack/react-query"
import axios from "axios"

type Variables = { workflowId: string; name?: string | null }

export function useExportWorkflowMutation() {
  return useMutation({
    mutationFn: async ({ workflowId, name }: Variables) => {
      const response = await axios.get<{ data: { file: string } }>(
        `/workflows/${workflowId}/export`,
      )
      const { file } = response.data.data

      const blob = new Blob([file], { type: "application/octet-stream" })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement("a")
      a.href = url
      a.download = `${name?.trim() || "workflow"}.permutflow`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
  })
}
